import { ROOT_CAUSE_ANALYSIS_ACTIONS } from "./action_types";

export const addRootCausePayload = (payload) => ({
  type: ROOT_CAUSE_ANALYSIS_ACTIONS.ROOT_CAUSE_PAYLOAD,
  payload: payload,
});
